import { axiosService } from '../.';

export default class GetOrganizationBusinessExternalLinksById {
    public async execute(businessId: number): Promise<GetOrganizationBusinessExternalLinksByIdDto[]> {
        const links = (await axiosService.instance.get(`businesses/organization/${businessId}/external-links`)).data;
        return links ? links.map((link: any) => new GetOrganizationBusinessExternalLinksByIdDto(link)) : [];
    }
}

export class GetOrganizationBusinessExternalLinksByIdDto {
    public readonly type: number;
    public readonly title: string;
    public readonly url: string;

    constructor(data: any) {
        this.type = data.type;
        this.title = data.title;
        this.url = data.url;
    }
}

export const getOrganizationBusinessExternalLinksById = new GetOrganizationBusinessExternalLinksById();
